/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { productCarouselStyles } from "@monsma/Overrides/Widgets/Common/ProductCarousel";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

productCarouselStyles.xngStyles = {
    wrapper: {
        css: css`
            &.hide-on-print {
                @media print {
                    display: none;
                }
            }
        `,
    },
    productTile: {
        productTileWrapper: {
            css: css`
              ${screen("lte", "xs")} {
                width: 100%;
              }
            `,
        },
    },
};

productCarouselStyles.titleText = {
    css: css`
        line-height: 34px;
        margin-bottom: 25px;

        > * {
            &:last-child {
                margin-bottom: 0;
            }
        }
    `,
};
